import { usePermissionsContext } from "@contexts/PermissionsContext";
const useEmailDomain = () => {
    const { domain, setDomain } = usePermissionsContext();
    return { domain, setDomain };
};
export default useEmailDomain;
